import type { ReactElement } from "react";

export interface BrandmarkProps {
  size?: number;
  color?: string;
}

export function Brandmark({ size = 36, color }: BrandmarkProps): ReactElement {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" style={{ display: "block" }}>
      <circle cx="18" cy="18" r="16" fill={color ?? "var(--brand)"} />
      <circle cx="18" cy="18" r="11" fill="none" stroke="white" strokeWidth="1.5" opacity="0.5" />
      <path
        d="M13 10 L13 26 M13 18 L22 10 M13 18 L22 26"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
